export const MenuType = {
  Secondary: 'secondary',
  Header: 'header',
  Footer: 'footer',
  FooterTeamColumns: 'footer_columns',
  FooterSocials: 'footer_socials',
} as const
